import React from 'react';
import {Suggestions} from 'components';

export function PositiveEmotions(props) {
  return (
    <Suggestions.List {...props}>
      <p>Joy</p>
      <p>Love</p>
      <p>Satisfaction</p>
      <p>Excitement</p>
      <p>Pride</p>
      <p>Delight</p>
      <p>Peace</p>
    </Suggestions.List>
  );
}
